import React, { useState, useRef, useEffect } from "react";
import faqsModel from "venuescanner-js/react/components/VirtualEvents/models/faqs";
import isSSR from "venuescanner-js/services/isSSR";

const Faqs = () => {
  const [activeFaq, setActiveFaq] = useState(faqsModel[0]);
  const animate = useRef(null);

  useEffect(() => {
    if (isSSR()) return;
    animate.current.classList.remove("visible");
    setTimeout(() => animate.current.classList.add("visible"), 1);
  }, [activeFaq]);

  const faqs = faqsModel.map((faq, index) => (
    <p
      key={faq.question + index}
      className={`virtual-events-faqs__question ${
        activeFaq.id === faq.id ? "isActive" : "isInactive"
      }`}
      onClick={() => setActiveFaq(faq)}
    >
      {faq.question}
    </p>
  ));
  return (
    <div className="virtual-events-faqs" ref={animate}>
      <h2 className="virtual-events-faqs__title">Frequently asked questions</h2>
      <div className="container">
        <div className="virtual-events-faqs__questions">{faqs}</div>
        <div className="virtual-events-faqs__answer">
          <img
            className="virtual-events-faqs__answer__quote"
            src="https://s3.eu-west-2.amazonaws.com/venue.scanner/img/virtual-events/quotes.png"
            alt="quotes"
          />
          <p>{activeFaq.answer}</p>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
